const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}

document.addEventListener('DOMContentLoaded', function () {
  // Ensure only the first 'order_dropdown_icon' and its corresponding accordion box are open
  document.querySelectorAll('.block_order_box_top_box').forEach(function (box, index) {
    const allIcons = box.querySelectorAll('.order_dropdown_icon');
    const allAccordionBoxes = box.querySelectorAll('.block_order_accrodion_box');

    // Reset all elements
    allIcons.forEach(icon => icon.classList.remove('active'));
    allAccordionBoxes.forEach(accordion => {
      accordion.classList.remove('active');
      accordion.style.display = 'none';
    });

    // Activate only the first child
    if (index === 0) {
      const firstIcon = box.querySelector('.order_dropdown_icon');
      const firstAccordionBox = box.querySelector('.block_order_accrodion_box');
      if (firstIcon && firstAccordionBox) {
        firstIcon.classList.add('active');
        firstAccordionBox.classList.add('active');
        firstAccordionBox.style.display = 'block';
      }
    }
  });

  // Ensure only the first 'mobile_dropdown' list item triggers the desktop dropdown
  const mobileDropdown = document.querySelector('.mobile_dropdown');
  if (mobileDropdown) {
    const allListItems = mobileDropdown.querySelectorAll('li');
    const desktopDropdown = document.querySelector('.desktop_dropdown');

    // Reset all list items and hide desktop dropdown
    allListItems.forEach(item => item.classList.remove('active'));
    if (desktopDropdown) desktopDropdown.style.display = 'none';

    // Activate only the first list item
    const firstListItem = mobileDropdown.querySelector('li');
    if (firstListItem && desktopDropdown) {
      firstListItem.classList.add('active');
      desktopDropdown.style.display = 'block';
    }
  }
});

// Handle click event on elements with the 'order_dropdown_icon' class
document.querySelectorAll('.order_dropdown_icon').forEach(function (icon) {
  icon.addEventListener('click', function () {
    // Toggle the active class on the clicked icon
    this.classList.toggle('active');

    // Find the corresponding accordion box and toggle its visibility
    const accordionBox = this.closest('.block_order_box_top_box').querySelector('.block_order_accrodion_box');
    if (accordionBox) {
      accordionBox.classList.toggle('active');
      // Toggle display: If currently visible, hide it, otherwise show it
      if (accordionBox.style.display === 'block') {
        accordionBox.style.display = 'none';
      } else {
        accordionBox.style.display = 'block';
      }
    }
  });
});



// document.addEventListener('DOMContentLoaded', function () {

//   const links = document.querySelectorAll('.block_customer_account_left_bottom_box ul li a');

//   // Check for saved active link in localStorage
//   let activeLink = localStorage.getItem('activeAccountLink');

//   // If no active link is saved, default to the first child
//   if (!activeLink && links.length > 0) {
//     activeLink = links[0].getAttribute('href'); // Set the first child's href as the active link
//     links[0].classList.add('active'); // Add the active class to the first child
//     localStorage.setItem('activeAccountLink', activeLink); // Save the first child's href to localStorage
//   } else if (activeLink) {
//     // If an active link is saved, apply the active class
//     links.forEach(link => link.classList.remove('active')); // Remove the active class from all links
//     const activeElement = document.querySelector(`.block_customer_account_left_bottom_box ul li a[href="${activeLink}"]`);
//     if (activeElement) {
//       activeElement.classList.add('active'); // Apply the active class to the saved link
//     }
//   }

//   // Add click event listeners to all links
//   links.forEach(link => {
//     link.addEventListener('click', function () {
//       // Save the clicked link's href to localStorage
//       localStorage.setItem('activeAccountLink', this.getAttribute('href'));

//       // Update active class
//       links.forEach(link => link.classList.remove('active'));
//       this.classList.add('active');
//     });
//   });

//       // Check if the screen width is below 767px
//       if (window.matchMedia('(max-width: 767px)').matches) {
//         // Dropdown logic
//         const dropdownItems = document.querySelectorAll(".desktop_dropdown .dropdown-item");
        
//         // Check for saved active index in localStorage
//         let savedActiveIndex = localStorage.getItem("activeDropdownIndex");
      
//         // If no index is saved, default to the first child
//         if (savedActiveIndex === null && dropdownItems.length > 0) {
//           savedActiveIndex = 0; // Default to the first child
//           dropdownItems[0].classList.add("active"); // Set the first child as active
//           localStorage.setItem("activeDropdownIndex", 0); // Save the first child as active
//         } else if (savedActiveIndex !== null && dropdownItems[savedActiveIndex]) {
//           dropdownItems[savedActiveIndex].classList.add("active"); // Apply saved active class
//         }
      
//         dropdownItems.forEach((item, index) => {
//           const link = item.querySelector(".dropdown-link");
//           link.addEventListener("click", function (event) {
//             // Prevent default action if already active
//             if (item.classList.contains("active")) {
//               event.preventDefault();
//             }
      
//             // Remove active class from all items
//             dropdownItems.forEach((el) => el.classList.remove("active"));
      
//             // Add active class to the clicked item
//             item.classList.add("active");
      
//             // Save the index of the clicked item in localStorage
//             localStorage.setItem("activeDropdownIndex", index);
      
//             // Optionally toggle the dropdown menu if needed
//             const dropdownMenu = document.querySelector(".desktop_dropdown");
//             if (dropdownMenu) {
//               dropdownMenu.classList.toggle("open");
//             }
//           });
//         });
//       }
      

// });

document.addEventListener("DOMContentLoaded", () => {
  const dropdownIcon = document.querySelectorAll(".account-tabs-icon");
  const dropdownMenu = document.querySelector(".desktop_dropdown");
  const dropdownItems = dropdownMenu.querySelectorAll(".dropdown-item");
  let count = 2
  const isMobileView = () => window.innerWidth <= 767;
  dropdownIcon.forEach((item) => {
    item.addEventListener("click", () => {
      if (isMobileView() && count % 2 == 0) {
        item.closest('li').classList.remove('active')
        dropdownIcon.forEach((li) => {
          li.closest('li').classList.add('active')
        });
        count++;
      }
      else{
        dropdownIcon.forEach((li) => {
          li.closest('li').classList.remove('active')
        });
        item.closest('li').classList.add('active')
        count++;
      }
    });
  }); 
});

